module.exports = __webpack_public_path__ + "static/media/27.831f6ee2.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/27.JPG
// module id = 470
// module chunks = 0